<template>
    <div class="center-me-no">
        <h4 style="margin: 0" class="white--text">{{text}}</h4>
        <v-btn text @click="$router.push('/add')" class="main mt-3">Add your fist task</v-btn>
    </div>
</template>

<script>
    export default {
        props: ["text"]
    }
</script>

<style>
.center-me-no {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>